import React, { useState, useCallback } from 'react';
import { TreasureChestAnimation } from '../components/TreasureChestAnimation';

const chestStyles = {
    bronze: { background: '#cd7f32', color: '#fff' },
    silver: { background: '#c0c0c0', color: '#000' },
    gold:   { background: '#ffd700', color: '#000' },
    diamond:{ background: '#b9f2ff', color: '#000' }
};

export function useToast() {
    const [messages, setMessages] = useState([]);
    const [activeChest, setActiveChest] = useState(null);

    const show = useCallback((text, type = 'default', chest = null, options = {}) => {
        const id = Math.random().toString(36);
        const style = chest && chestStyles[chest] ? chestStyles[chest] : {};

        const msg = {
            id,
            text,
            type,
            style,
            chest
        };

        setMessages(prev => [...prev, msg]);

        if (chest) {
            setActiveChest(chest);
        }

        setTimeout(() => {
            setMessages(prev => prev.filter(m => m.id !== id));
        }, options.duration || 4000);
    }, []);

    const showSuccess = useCallback((text) => {
        show(text, 'success');
    }, [show]);

    const showError = useCallback((text) => {
        show(text, 'error');
    }, [show]);

    const showInfo = useCallback((text) => {
        show(text, 'info');
    }, [show]);

    const Toasts = () => (
        <>
            {/* Schatztruhe Animation direkt in der App anzeigen */}
            {activeChest && (
                <div style={{
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    zIndex: 9999,
                    pointerEvents: 'none'
                }}>
                    <TreasureChestAnimation
                        type={activeChest}
                        onDone={() => setActiveChest(null)}
                    />
                </div>
            )}

            {/* Normale Toasts */}
            <div style={{ position: 'fixed', top: 20, right: 20, zIndex: 9999 }}>
                {messages.map((m) => {
                    let background = '#333';
                    let color = '#fff';

                    if (m.type === 'success') background = '#52c41a';
                    if (m.type === 'error') background = '#f5222d';
                    if (m.type === 'info') background = '#1890ff';

                    if (m.style && m.style.background) background = m.style.background;
                    if (m.style && m.style.color) color = m.style.color;

                    return (
                        <React.Fragment key={m.id}>
                            <div style={{
                                background,
                                color,
                                padding: '0.75rem 1.25rem',
                                borderRadius: '8px',
                                marginBottom: '0.5rem',
                                boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
                                fontWeight: 'bold',
                                fontSize: '1rem'
                            }}>
                                {typeof m.chest === 'string' ? `🎁 ${m.text}` : m.text}
                            </div>
                        </React.Fragment>
                    );
                })}
            </div>
        </>
    );

    return { show, showSuccess, showError, showInfo, Toasts };
}
